export const POPUP_BLOCKED_ORIGIN = {
  DEFAULT: 'default',
  SITE_CREATED_WITH_HG_BUILDER: 'site_created_with_hg_builder',
  OPEN_HG_BUILDER_EDITOR: 'open_hg_builder_editor',
};
